import { render, staticRenderFns } from "./transferliste.vue?vue&type=template&id=648cb021&scoped=true&"
import script from "./transferliste.vue?vue&type=script&lang=js&"
export * from "./transferliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648cb021",
  null
  
)

export default component.exports